<template>
  <div>
    <div class="row">
      <div class="col-7 col-sm-9 form-group mb-0 pb-4">
        <label for="password">Password</label>
        <p v-if="!editing" class="mb-0 lead text-muted">
          ••••••••••••••••
        </p>

        <div v-else>
          <div class="row">
            <div class="col-7 col-sm-9 form-group">

              <TextInput
                v-model="form.current_password"
                :errors="errors ? errors.current_password : []"
                type="password"
                autofocus
                autocapitalize="off"
                label="Your current password"
                @input="errors = null"
                validateError
              />

            </div>

            <div class="col-7 col-sm-9 form-group">
              <TextInput
                v-model="form.password"
                label="New password"
                :errors="errors ? errors.password : []"
                type="password"
                autofocus
                autocapitalize="off"
                @input="errors = null"
                validateError
              />
            </div>
            <div class="col-7 col-sm-9 form-group">
              <TextInput
                v-model="form.password_confirmation"
                label="Confirm new password"
                :errors="errors ? errors.password_confirmation : []"
                type="password"
                autofocus
                autocapitalize="off"
                @input="errors = null"
                validateError
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-5 col-sm-3 pb-4 d-flex flex-column justify-content-start">
        <button
          v-if="!editing"
          @click.prevent="editing = true"
          class="btn btn-primary"
        >
          Update password
        </button>
        <div v-else class="d-flex">
          <button
            @click.prevent="cancel"
            class="btn btn-secondary flex-grow-1 mr-1"
          >
            Cancel
          </button>
          <button
            @click.prevent="save"
            class="btn btn-primary flex-grow-1 ml-1"
            :disabled="saving"
          >
            {{ saving ? "Saving" : "Save" }}
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import TextInput from '@/Shared/Inputs/Text';

export default {

  components: {
    TextInput,
  },

  props: {
    id: {
      type: String,
      require: true,
    },
  },

  data() {
    return {
      saving: false,
      editing: false,
      errors: null,

      form: {
        current_password: null,
        password: null,
        password_confirmation: null,
      },
    };
  },

  methods: {
    cancel() {
      this.saving = false;
      this.editing = false;
      this.errors = null;
      this.form.current_password = null;
      this.form.password = null;
      this.form.password_confirmation = null;
    },
    save() {
      this.saving = true;

      this.$nextTick(() => {
        window.axios
          .put(`/user/${this.id}`, this.form)
          .then(() => {
            this.cancel();
          })
          .catch((error) => {
            this.saving = false;
            this.errors = error.response.data.errors;
            throw new Error(error);
          });
      });
    },
  },
};
</script>
